import { RetailerKey } from 'flow/types/EntityKeys';

//NOTE! This is not a complete list of all retailers
export const Retailers = Object.freeze({
    TELAVOX: 'retailer-1',
    JSC: 'retailer-745',
    ATEA: 'retailer-755',
    ANDORRA_TELECOM: 'retailer-768',
    CLARO_PERU: 'retailer-672',
    INVOSYS: 'retailer-795',
    TUSASS: 'retailer-784',
    ALLESCLOUD: 'retailer-841',
    FRONTDESK: 'retailer-675',
    VOICEFLEX: 'retailer-863',
    INTERNETPORT: 'retailer-875',
    FREEPRO: 'retailer-853', // Previously called Jaguar
    VOIP_UNLIMITED: 'retailer-813',
    HALLO: 'retailer-934',
    ERIZON: 'retailer-927',
    CLEVIT: 'retailer-867',
    ARK_CONNECT: 'retailer-933',
    FLEXIP: 'retailer-899',
    MSCOM: 'retailer-868',
    ICTFORMORE: 'retailer-882',
    ADITCO: 'retailer-900',
    CLOUDPOINT: 'retailer-847',
    TPCCLOUD: 'retailer-943',
    ITEXPERTS: 'retailer-903',
    CLOUD_HIGHWAY: 'retailer-1006',
    STILAN_BV: 'retailer-905',
    COMIVIA: 'retailer-874',
    GLOBE: 'retailer-835',
    XO_TELECOM: 'retailer-930',
    NOOMADOO_LTD: 'retailer-1028',
    ELEMENTEL_LTD: 'retailer-1029',
    HYBRID_COMMUNICATIONS_LIMITED: 'retailer-1030',
    BESPOKE_CONNECTED_LTD: 'retailer-1031',
    TEMOVI: 'retailer-1004',
    BELCENTER: 'retailer-1003',
    YIBBLO: 'retailer-1075',
    FIRSTCOM: 'retailer-1094',
    NEWTECH: 'retailer-992',
    WE_ARE_ON_IT: 'retailer-1143',
    STJARNAFYRKANT: 'retailer-497',
    ETISALAT: 'retailer-1251',
    ALCOM: 'retailer-1316',
    TELEPROFFS: 'retailer-1358',
    RAINBOW: 'retailer-1211',
});

export const retailerKeysDisallowingConnectedServices: RetailerKey[] = [
    Retailers.FREEPRO,
];
